import slugify from "slugify";

export const slugifyString = (string: string) => {
  string = string.replace(/[<>$%&|]+/g, "");
  return slugify(string, {
    replacement: "_",
    lower: true,
    remove: /[*+~.()'"!:@$%&<>]/g,
    strict: true,
  });
};
